import { useState } from "react";
import { api } from "../../../../../../utility/api";

export const ConsumidoresFinalesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getConsumidoresFinales = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("consumidores_finales", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteConsumidorFinal = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`consumidores_finales/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getDetalleConsumidorFinal = async (id) => {
        try {
            setCargando(true);
            const response = await api.get(`consumidores_finales/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearConsumidorFinal = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("consumidores_finales", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarConsumidorFinal = async (id, data) => {
        try {
            setCargando(true);
            const response = await api.put(`consumidores_finales/${id}`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const agregarClienteConsumidorFinal = async (id, clienteId) => {
        try {
            setCargando(true);
            const response = await api.post(
                `consumidores_finales/${id}/agregar_cliente`,
                { cliente_id: clienteId },
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const quitarClienteConsumidorFinal = async (id, clienteId) => {
        try {
            setCargando(true);
            const response = await api.post(
                `consumidores_finales/${id}/quitar_cliente`,
                { cliente_id: clienteId },
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getClientes = async (params) => {
        return api
            .get("cliente", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getConsumidoresFinales,
        deleteConsumidorFinal,
        getDetalleConsumidorFinal,
        crearConsumidorFinal,
        actualizarConsumidorFinal,
        agregarClienteConsumidorFinal,
        quitarClienteConsumidorFinal,
        getClientes,

        cargando,
    };
};
